import TopBar from '../components/TopBar';
import { usePeriod } from '../hooks/usePeriod';

// Rendered for /section/:period/:sectionKey when that route period isn't one of
// the caller's applicable active periods (closed, gated out, or unknown).
export default function PeriodClosed() {
  const { periodLabel } = usePeriod();
  return (
    <>
      <TopBar />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: 'calc(100vh - 52px)', gap: 12 }}>
        <i className="fas fa-lock" style={{ fontSize: '3rem', color: '#7a2020' }} />
        <h2 style={{ margin: 0, color: '#7a2020' }}>Period Closed</h2>
        <p style={{ color: '#555', margin: 0 }}>
          {periodLabel
            ? `The ${periodLabel} data integrity period is no longer accepting input.`
            : 'This data integrity period is no longer accepting input.'}
        </p>
        <p style={{ color: '#888', fontSize: '0.85rem' }}>Contact an admin if you believe this is an error.</p>
      </div>
    </>
  );
}
